<template>
  <div ref="form" class="user-form">
    <a-spin :spinning="isPrecising">
      <a-form :form="form" v-bind="formItemLayout">
        <a-form-item
          class="user-type"
          label="您在项目还是公司工作:"
          v-bind="radioGroupLayout"
        >
          <a-radio-group
            v-decorator="[
              'workIn',
              {
                validateTrigger: 'blur',
                initialValue: registerType,
              },
            ]"
            name="radioGroup"
            @change="onregisterTypeChange"
          >
            <a-radio :value="inProject"> 项目 </a-radio>
            <a-radio :value="inCompany"> 公司 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="手机号">
          <a-input :disabled="true" :default-value="user.phone" />
        </a-form-item>
        <a-form-item
          label="姓名"
          extra="姓名将影响企业管理员进行成员管理，请填写真实姓名"
        >
          <a-input
            v-decorator="[
              'name',
              {
                validateTrigger: 'blur',
                initialValue: user.name,
                rules: [{ required: true, message: '请填写姓名!' }, { max: 10, message: '姓名不能超过10个字!'}],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="公司名称"
          extra="请输入5个及以上的关键字进行公司查找"
        >
          <a-select
            v-decorator="[
              'company',
              {
                validateTrigger: 'blur',
                initialValue: user.company,
                rules: [
                  { required: true, message: '请填写公司!' },
                  { validator: validatorCompany },
                ],
              },
            ]"
            placeholder="请输入真实公司名称，便于给贵司提供免费培训等服务"
            :options="companies"
            :show-search="true"
            :get-popup-container="getPopupContainer"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            mode="combobox"
            @search="onCompanySearchFuzzy"
            @blur="onCompanySearchPrecise"
            @change="handleCompanyChange"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          </a-select>
        </a-form-item>
        <a-form-item v-if="showArea" label="企业所在省市">
          <a-cascader
            v-decorator="[
              'companyProvince',
              {
                rules: [
                  {
                    type: 'array',
                    required: true,
                    message: '请选择企业所在省市!',
                  },
                ],
              },
            ]"
            :field-names="{
              label: 'name',
              value: 'code',
              children: 'children',
            }"
            :options="areasOptions"
            :load-data="loadData"
            placeholder="请选择企业所在省市"
            @change="onChangeAreas"
          ></a-cascader>
        </a-form-item>
        <a-form-item
          v-if="isProject"
          label="项目名称"
          extra="请输入3个及以上的关键字进行项目查找"
        >
          <a-select
            v-decorator="[
              'project',
              {
                validateTrigger: 'blur',
                initialValue: user.project,
                rules: [
                  { required: true, message: '请填写项目!' },
                  { validator: validatorProject },
                ],
              },
              ]"
              placeholder="请输入真实项目，如在公司请输入公司名"
              :show-search="true"
              :get-popup-container="getPopupContainer"
              :not-found-content="fetching2 ? undefined : null"
              :filter-option="false"
              mode="combobox"
              @search="onProjectSearchFuzzy"
              @blur="onProjectSearchPrecise"
              @change="handleChange"
            >
             <a-select-option v-for="item in projects" :key="item.id" :value="item.name">
              {{ item.name }}
            </a-select-option>
            <a-spin v-if="fetching2" slot="notFoundContent" size="small" />
          </a-select>
        </a-form-item>
        <a-form-item v-if="isProject" label="项目阶段">
          <a-select
            v-decorator="[
              'projectStage',
              {
                validateTrigger: 'blur',
                initialValue: user.projectStage ? user.projectStage : undefined,
                rules: [{ required: true, message: '请选择当前阶段!' }],
              },
            ]"
            :options="stages"
            placeholder="请选择项目阶段"
            :get-popup-container="getPopupContainer"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="岗位">
          <a-select
            v-decorator="[
              'position',
              {
                validateTrigger: 'blur',
                initialValue: user.position ? user.position : undefined,
                rules: [{ required: true, message: '请填写岗位!' }],
              },
              ]"
              :options="positions"
              placeholder="请输入真实岗位，以为您提供专业服务"
              :get-popup-container="getPopupContainer"
          ></a-select>
        </a-form-item>
        <div class="trial-actions">
          <a-button type="primary" @click="onCompleteClick">提交</a-button>
        </div>
      </a-form>
    </a-spin>
  </div>
</template>
<script>
import {
  Form,
  Input,
  Select,
  Button,
  Spin,
  Radio,
  message,
  Cascader,
} from "ant-design-vue";
import debounce from "@/utils/debounce";
// import maiFn from '@/utils/maidian'
import UserEnterpriseApi from "@/api/userEnterpriseApi.js";

const INPROJECT = 0;
const INCOMPANY = 1;
const STAGES = [
  { key: "项目立项阶段", title: "项目立项阶段" },
  { key: "设计阶段", title: "设计阶段" },
  { key: "基础阶段", title: "基础阶段" },
  { key: "临建阶段", title: "临建阶段" },
  { key: "招投标阶段", title: "招投标阶段" },
  { key: "中标阶段", title: "中标阶段" },
  { key: "主体阶段", title: "主体阶段" },
  { key: "装修阶段", title: "装修阶段" },
  { key: "竣工阶段", title: "竣工阶段" },
];

const POSITIONS = [
  { key: "董事长", title: "董事长" },
  { key: "总经理", title: "总经理" },
  { key: "副总经理", title: "副总经理" },
  { key: "书记", title: "书记" },
  { key: "总工程师", title: "总工程师" },
  { key: "副总工程师", title: "副总工程师" },
  { key: "总经济师", title: "总经济师" },
  { key: "财务经理", title: "财务经理" },
  { key: "生产经理", title: "生产经理" },
  { key: "商务经理", title: "商务经理" },
  { key: "信息中心主任", title: "信息中心主任" },
  { key: "安全经理", title: "安全经理" },
  { key: "质量经理", title: "质量经理" },
  { key: "院长", title: "院长" },
  { key: "部门经理", title: "部门经理" },
  { key: "项目经理", title: "项目经理" },
  { key: "技术员", title: "技术员" },
  { key: "其他", title: "其他" },
  { key: "物资经理", title: "物资经理" },
  { key: "劳务经理", title: "劳务经理" },
  { key: "会长", title: "会长" },
  { key: "副会长", title: "副会长" },
  { key: "秘书长", title: "秘书长" },
  { key: "厅长", title: "厅长" },
  { key: "副厅长", title: "副厅长" },
  { key: "局长", title: "局长" },
  { key: "副局长", title: "副局长" },
  { key: "科长", title: "科长" },
  { key: "副科长", title: "副科长" },
  { key: "办公室主任", title: "办公室主任" },
  { key: "BIM中心主任", title: "BIM中心主任" },
  { key: "安全副总", title: "安全副总" },
  { key: "安全员", title: "安全员" },
  { key: "采购经理", title: "采购经理" },
  { key: "采购员", title: "采购员" },
  { key: "成本副总", title: "成本副总" },
  { key: "出纳员", title: "出纳员" },
  { key: "工程部经理", title: "工程部经理" },
  { key: "合约经理", title: "合约经理" },
  { key: "合约专员", title: "合约专员" },
  { key: "会计员", title: "会计员" },
  { key: "技术负责人", title: "技术负责人" },
  { key: "劳资员", title: "劳资员" },
  { key: "企划部经理", title: "企划部经理" },
  { key: "审计经理", title: "审计经理" },
  { key: "文员", title: "文员" },
  { key: "物资管理员", title: "物资管理员" },
  { key: "预算员", title: "预算员" },
  { key: "质量员", title: "质量员" },
  // { key: '生产经理', title: '生产经理' },
  { key: "技术总工", title: "技术总工" },
  { key: "BIM工程师", title: "BIM工程师" },
  { key: "BIM负责人 ", title: "BIM负责人" },
];

export default {
  name: "UserForm",
  components: {
    AForm: Form,
    AFormItem: Form.Item,
    AInput: Input,
    AButton: Button,
    ASelect: Select,
    ASelectOption: Select.Option,
    ASpin: Spin,
    ARadio: Radio,
    ARadioGroup: Radio.Group,
    ACascader: Cascader,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      radioGroupLayout: {
        labelCol: { span: 9 },
        wrapperCol: { span: 15 },
      },
      stages: STAGES,
      positions: [],
      // 公司信息
      companies: [],
      // companyInfo: {},
      // companySure: null,
      // companyProvince: null,
      // 项目信息
      projects: [],
      searchProjectId: null,
      // projectInfo: null,
      // projectSure: null,
      fetching: false,
      fetching2: false,
      inProject: INPROJECT,
      inCompany: INCOMPANY,
      isProject: this.user.project !== "",
      areasOptions: [],
      showArea: false,
      isPrecising: false,
    };
  },
  computed: {
    registerType() {
      return this.user.project !== "" ? this.inProject : this.inCompany;
    },
  },
  created() {
    this.onCompanySearchFuzzy = debounce(this.onCompanySearchFuzzy, 500);
    this.onProjectSearchFuzzy = debounce(this.onProjectSearchFuzzy, 100);
    // this.$ga.event("剩余授权下方购买", "click", "client");
  },
  mounted() {
    const { sgyToken, globalId, version, getPosition } = UserEnterpriseApi;
    getPosition().then(res => {
      this.positions = res.data.map(item => {
        return {
          key: item.name,
          title: item.name
        }
      })
    })
    // maiFn(sgyToken, globalId, version, 'show', this, "页面展示")
  },
  methods: {
    validator(rule, value, callback) {
      if (value && value === Number.parseFloat(value).toString()) {
        callback(new Error("请输入正确的内容"));
      } else {
        callback();
      }
    },
    validatorCompany(rule, value, callback) {
      if (value && value.length < 5) {
        callback(new Error("请输入5个及以上的关键字"));
      } else {
        callback();
      }
    },
    validatorProject(rule, value, callback) {
      if (value && value.length < 3) {
        callback(new Error("请输入3个及以上的关键字"));
      } else {
        callback();
      }
    },
    onCompleteClick() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.user.project = values.project || "";
          this.user.company = values.company || null;
          this.user.name = values.name || null;
          this.user.position = values.position || null;
          this.user.projectStage = values.projectStage || null;
          // this.user.globalId = this.user.globalid
          this.user.companyProvince = this.user.province;
          this.user.tabType = values.workIn;
          if (values.workIn === this.inCompany) {
            this.user.projectAddress = null;
            this.user.projectProvince = null;
            this.user.projectSure = null;
          }
          // if (this.user.companyProvince !== null) {
            const res = await UserEnterpriseApi.completeUserInfo({
              ...this.user,
              source: UserEnterpriseApi.source,
            });
            if (res.code === 0) {
              message.success('完善信息成功')
              const { sgyToken, globalId, version, source} = UserEnterpriseApi;
              this.$ga.event("完善信息", "click", "client");
              // maiFn(sgyToken, globalId, version, 'click', this, "完善信息", source)
              if (UserEnterpriseApi.source === "ZPERT") {
                // maiFn(sgyToken, globalId, version, 'click', this, "完善信息", source)
                if (res.data === 2 || res.data === 3) {
                  this.$router.push({
                    path: "/result",
                    query: { type: res.data, 'sgy-token': sgyToken, globalId, version },
                  });
                } else {
                  this.$router.push({
                    path: '/register-result',
                    query: { source },
                  })
                }
              } else {
                this.$router.push({
                  path: '/register-result',
                  query: { source },
                })
              }
            } else {
              message.error(res.msg);
            }
          // } else {
          //   message.error("企业加载中...，请稍后点击提交");
          // }
        }
      });
    },
    getPopupContainer() {
      return this.$refs.form;
    },
    onregisterTypeChange(e) {
      const { value } = e.target;
      if (value === this.inProject) {
        this.isProject = true;
      } else {
        this.isProject = false;
        this.projectInfo = null;
        this.projectSure = null;
      }
    },
    // 公司搜索
    async onCompanySearchFuzzy(value) {
      this.fetching = true;
      if (value) {
        const res = await UserEnterpriseApi.getCompanyList(value);
        const { data, status } = res;
        if (status) {
          if (data !== null) {
            const companies = [];
            for (let i = 0; i < data.length; i++) {
              const name = data[i].enterpriseName;
              companies.push({ key: name, title: name });
            }
            this.companies = companies;
          }
        } else {
          message.error(res.msg);
        }
      }
      this.fetching = false;
    },
    async onCompanySearchPrecise(value) {
      if (value) {
        this.isPrecising = true;
        try {
          const res = await UserEnterpriseApi.getCompanyInfo(value);
          const { status, data } = res;
          if (status && data !== null) {
            const {
              enterpriseAddress,
              area,
              socialCreditCode,
              registeredCapital,
            } = data;
            this.user.companyAddress = enterpriseAddress || null;
            this.user.province = area || null;
            this.user.socialCreditNum = socialCreditCode || null;
            this.user.registeredCapital = registeredCapital || null;
            this.user.companySure = 1;
            this.showArea = false;
          } else {
            this.user.companySure = 0;
            this.user.companyAddress = null;
            this.user.socialCreditNum = null;
            this.user.registeredCapital = null;
            this.showArea = true;
            this.getAdministrativeAreas();
            if(!status)message.error(res.msg);
          }
          this.isPrecising = false;
        } catch(err) {
          this.user.companySure = 0;
          this.user.companyAddress = null;
          this.user.socialCreditNum = null;
          this.user.registeredCapital = null;
          this.showArea = true;
          this.getAdministrativeAreas();
          // message.error(err.message);
          this.isPrecising = false;
        }
      }
    },
    handleCompanyChange(value) {
      this.user.province = null;
    },
    // 项目搜索
    async onProjectSearchFuzzy(value) {
      this.fetching2 = true;
      if (value && value.length >= 3) {
        const res = await UserEnterpriseApi.getProjectList(value);
        const { data, status } = res;
        if (status) {
          if (data !== null) {
            const projects = [];
            for (let i = 0; i < data.length; i++) {
              const name = data[i].projectName;
              const id = `${data[i].id}`;
              projects.push({ id: id, name: name });
            }
            this.projects = projects;
          }
        } else {
          message.error(res.msg);
        }
      }
      this.fetching2 = false;
    },
    handleChange(value, e) {
      this.searchProjectId = e.data.key;
    },
    async onProjectSearchPrecise() {
      if (this.searchProjectId && this.searchProjectId >= 3) {
        const res = await UserEnterpriseApi.getProjectInfo(
          this.searchProjectId
        );
        const { status, data } = res;
        if (status && data !== null) {
          const { projectAddress, province, constructionCost, floorArea } = data;
          this.user.projectAddress = projectAddress || null;
          this.user.projectProvince = province || null;
          this.user.projectSure = 1;
          this.user.projectCost = constructionCost ?? null;
          this.user.floorArea = floorArea ?? null;
        }
      } else {
        this.user.projectSure = 0;
        this.user.projectAddress = null;
        this.user.projectProvince = null;
      }
    },
    // 获取省市初始化
    async getAdministrativeAreas() {
      const res = await UserEnterpriseApi.getAdministrativeAreas("0");
      this.areasOptions = res.areas.map((item) => {
        item.isLeaf = false;
        return item;
      });
    },
    async loadData(e) {
      const targetOption = e[e.length - 1];
      targetOption.loading = true;
      const data = await UserEnterpriseApi.getAdministrativeAreas(
        targetOption.code
      );
      targetOption.loading = false;
      targetOption.children = [...data.areas];
      this.areasOptions = [...this.areasOptions];
    },
    onChangeAreas(value, selectedOptions) {
      const areas = selectedOptions.map((item) => {
        return item.name;
      });
      this.user.companySure = 0;
      this.user.province = areas[0];
    }
  }
};
</script>

<style scoped>
.trial-complete {
  min-height: 400px;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title {
  text-align: center;
  margin: 20px auto;
}
.title h3 {
  color: #1890ff;
}
.trial-form {
  width: 450px;
  margin: auto;
}
.trial-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.trial-actions button {
  width: 300px;
  margin-bottom: 20px;
}
.start-trial-btn {
  width: 220px;
}
.user-type ::v-deep .ant-form-item-control-wrapper {
  text-align: left;
  top: -3px;
  padding-left: 15px;
}
::v-deep .ant-form-explain,
::v-deep .ant-form-extra {
  text-align: left;
}
::v-deep .ant-cascader-picker .ant-cascader-picker-label {
  text-align: left;
}
</style>
